import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

const ThankYouPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const formType = searchParams.get('type') || 'contact';
  const source = searchParams.get('source') || 'unknown';

  const getContent = () => {
    switch (formType) {
      case 'recruiter_contact':
        return {
          title: 'Request Received',
          message: 'We\'ve received your information and a member of our team will reach out to schedule a call, typically within 3-5 business days.',
          icon: '📞'
        };
      case 'info_request':
        return {
          title: 'Information Sent!',
          message: 'We\'ve received your request and a member of our team will be in touch to provide the information you requested.',
          icon: '📧'
        };
      case 'application':
        return {
          title: 'Application Received',
          message: 'We\'ve received your application and our team will review it carefully. We typically reach out within 3-5 business days with next steps.',
          icon: '📋'
        };
      default:
        return {
          title: 'Thank You',
          message: 'We\'ve received your submission and will be in touch soon.',
          icon: '✅'
        };
    }
  };

  const content = getContent();

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-md shadow-2xl">
        {/* Header */}
        <div className="bg-kiloterra-dark px-6 py-8 text-center">
          <div className="flex items-center justify-center mb-4">
            <img 
              src="/kiloterra_logo_stacked_simple_grey.png" 
              alt="KILOTERRA Logo" 
              className="h-8 w-auto brightness-0 invert"
            />
          </div>
          <h1 className="text-2xl font-bold text-white uppercase mb-2">
            Thank You for Your Interest
          </h1>
          <p className="text-gray-200">
            We appreciate you taking the time to connect with KILOTERRA
          </p>
        </div>

        {/* Content */}
        <div className="px-6 py-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-green-100 mx-auto mb-4 flex items-center justify-center">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
              </svg>
            </div>
            <h2 className="text-xl font-bold text-kiloterra-dark mb-4 uppercase">
              {content.title}
            </h2>
            <p className="text-gray-600 mb-4">
              {content.message}
            </p>
            {content.note && (
              <div className="bg-kiloterra-yellow bg-opacity-20 p-3 text-sm text-kiloterra-dark font-medium mb-4">
                {content.note}
              </div>
            )}
            <button
              onClick={() => navigate('/')}
              className="bg-kiloterra-yellow text-kiloterra-dark px-6 py-2 font-bold hover:bg-opacity-90 transition-all duration-300 uppercase tracking-wide"
            >
              Return to Homepage
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ThankYouPage;